import { ReactElement, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Button } from "@mui/material";

import PageContainer from "../components/shared/PageContainer";
import TemplateForm from "../components/template/TemplateForm";
import * as Objects from "../services/api";
import { DefaultSetID } from "../services/api/TemplateSets";

function TemplateCreate() {
  const navigate = useNavigate();
  const { name } = useParams();
  const [template, setTemplate] = useState<Objects.Template>(
    new Objects.Template({
      name: name!,
      segment_length: 0,
      set_ids: [DefaultSetID],
    } as Objects.Template),
  );
  const [templateSets, setTemplateSets] = useState<Objects.TemplateSetAggregate[]>([]);

  useEffect(() => {
    Objects.TemplateSets.list().then(setTemplateSets);
  }, []);

  const onCreate = async () => {
    // Showing the default set is just for visuals, and since the backend doesn’t want the client to send it, we’re removing it before the request goes out
    const templateWithoutDefaultSet = new Objects.Template({
      ...template,
      set_ids: template.set_ids.filter((id) => id !== DefaultSetID),
    });
    await templateWithoutDefaultSet.create();
    navigate("/templates");
  };

  const actionButtons = (): ReactElement => {
    const hasError = template.hasErrors(template.validate());
    return (
      <Button sx={{ mr: "7pt", mt: "10pt" }} onClick={onCreate} variant="contained" disabled={hasError}>
        Create
      </Button>
    );
  };

  return (
    <PageContainer>
      <TemplateForm
        actionButtons={actionButtons()}
        template={template}
        setTemplate={setTemplate}
        templateSets={templateSets}
      ></TemplateForm>
    </PageContainer>
  );
}

export default TemplateCreate;
